import { render, staticRenderFns } from "./OfferConfigure.vue?vue&type=template&id=483892e4&scoped=true&"
import script from "./OfferConfigure.vue?vue&type=script&lang=js&"
export * from "./OfferConfigure.vue?vue&type=script&lang=js&"
import style0 from "./OfferConfigure.vue?vue&type=style&index=0&id=483892e4&scoped=true&lang=css&"
import style1 from "./OfferConfigure.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483892e4",
  null
  
)

export default component.exports